// Copyright (c) 2026 Finerty Data Ltd. All rights reserved.
//
// This file is part of proprietary software owned by Finerty Data Ltd.
// It is confidential and may not be copied, distributed, modified, or used,
// in whole or in part, without the prior written consent of Finerty Data Ltd.
//
// Author: Rafael Pereira Satyro

import type { Icon } from 'iconsax-react';

const StatusClockIcon: Icon = ({ size = 16, color, variant: _variant, className, style, ...rest }) => {
  const fill = color || 'currentColor';
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 15 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      style={style}
      {...rest}
    >
      <path d="M7.16667 14.3333C3.21333 14.3333 0 11.12 0 7.16667C0 3.21333 3.21333 0 7.16667 0C11.12 0 14.3333 3.21333 14.3333 7.16667C14.3333 11.12 11.12 14.3333 7.16667 14.3333ZM7.16667 1C3.76667 1 1 3.76667 1 7.16667C1 10.5667 3.76667 13.3333 7.16667 13.3333C10.5667 13.3333 13.3333 10.5667 13.3333 7.16667C13.3333 3.76667 10.5667 1 7.16667 1Z" fill={fill} />
      <path d="M9.63985 9.78621C9.55318 9.78621 9.46651 9.76621 9.38651 9.71287L7.31985 8.47954C6.80651 8.17287 6.42651 7.49954 6.42651 6.90621V4.17285C6.42651 3.89952 6.65318 3.67285 6.92651 3.67285C7.19985 3.67285 7.42651 3.89952 7.42651 4.17285V6.90621C7.42651 7.14621 7.62651 7.49954 7.83318 7.61954L9.89985 8.85287C10.1398 8.99287 10.2132 9.29954 10.0732 9.53954C9.97318 9.69954 9.80651 9.78621 9.63985 9.78621Z" fill={fill} />
    </svg>
  );
};

export { StatusClockIcon };
